<template>
  <div ref="merkmalCard" class="card" style="display: inline-block">
    <div ref="merkmal" :id="$id('merkmal-gesamt')" :class="borderColor">
      <Header ref="header" :data-id="$id('header')"
              :name="merkmal.i18NName" :visible="isSelected" v-on:reset-elements="resetRadios"
              :i18NPictureId="merkmal.i18NPictureId"
              :i18NDescription="merkmal.i18NDescription"/>
      <div class="custom-control custom-radio">
        <div v-for="(wert, index) in merkmal.merkmalsWerte" v-bind:key="wert.name">
          <input ref="radioButtons" type="radio" class="custom-control-input"
                 :id="$id('merkmal-radio-button' + index)"
                 :name="merkmal.name"
                 :disabled="wert.disabled"
                 :value="wert"
                 @change="triggerVorzugswertReminder(wert)"
                 v-model="selected">
          <label class="custom-control-label" :for="$id('merkmal-radio-button' + index)"
                 :style="((selected != null && wert.name===selected.name)? 'font-weight:500' : '')">
            <span v-html="wert.i18NName"/>
            <Vorzugswert :vorzugswert="wert.vorzugswert"/>
            <I18NImage :i18-n-pic-id="wert.i18NPictureId" :pic-title="wert.i18NName" :i18-n-description="wert.i18NDescription"/>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/config-page/utils/Header";
import Vorzugswert from "@/components/config-page/utils/Vorzugswert";
import I18NImage from "@/components/config-page/utils/I18NImage";
import isEmpty from "@/mixins/isempty";

export default {
  name: 'Merkmal',
  components: {I18NImage, Vorzugswert, Header},
  props: ['merkmal'],
  mixins: [isEmpty],
  data: function() {
    return {
      isTheChangedOne: false
    }
  },
  computed: {
    isSelected: function() {
      return !(this.isEmpty(this.$props.merkmal.selected));
    },
    borderColor: function() {
      if (this.isSelected) {
        return 'card-body green-left-border';
      }
      return 'card-body orange-left-border';
    },
    selected: {
      get() {
        return this.merkmal.selected
      },
      set(value) {
        this.commitSetSelectedMerkmal(value);
      }
    },
  },
  watch: {
    merkmal: {
      handler: function(merkmal, oldMerkmal) {
        if (!this.isTheChangedOne && JSON.stringify(merkmal) !== JSON.stringify(oldMerkmal)) {
          this.$refs.merkmalCard.classList.add('mark-change');
          setTimeout(() => { // remove after animation
            this.$refs.merkmalCard.classList.remove('mark-change');
          }, 2000);
        }
        this.isTheChangedOne = false;
      },
      deep: true
    },

  },
  methods: {
    resetRadios() {
      this.commitSetSelectedMerkmal(null);
    },
    commitSetSelectedMerkmal(value) {
      this.isTheChangedOne = true
      let merkmal = this.merkmal;
      this.$store.commit('setSelectedMerkmal', {merkmal:merkmal, value:value})
    },
    triggerVorzugswertReminder(wert) {
      for (let i = 0; i < this.merkmal.merkmalsWerte.length; i++) {
        if (this.merkmal.merkmalsWerte[i].vorzugswert && !wert.vorzugswert) {
          this.$store.commit('setNotificationContent', {variant: 'warning', title: this.$i18n.t('vorzugswert.alertTitle'), text: this.$i18n.t('vorzugswert.alertText'), dontHide: false});
          this.$store.commit('showNotification');
          return
        }
      }
    }
  },
}
</script>

<style scoped>


</style>